export const toYouTubeEmbed = (url) => {
  if (!url) return '';
  if (url.includes('/embed/')) return url;
  let id = '';
  const watch = url.match(/[?&]v=([^&]+)/);
  const short = url.match(/youtu\.be\/([^?&]+)/);
  const live = url.match(/youtube\.com\/live\/([^?&]+)/);
  if (watch) id = watch[1];
  else if (short) id = short[1];
  else if (live) id = live[1];
  if (!id) return url;
  return `https://www.youtube.com/embed/${id}`;
};
